import LocationRules from './LocationRules';

//Interface
import { IForm } from '@ts/ui-models';
import { CElement, CElementType } from '@ts/ui-models';

interface ILocationRulesProp extends IForm {
  values: CElement | CElementType;
}

const LocationRulesTab = (props: ILocationRulesProp) => {
  return <LocationRules {...props} />;
};

export default LocationRulesTab;
